export interface ExportSettingNode {
  label: string;
  value: boolean | 'indeterminate';
  children?: ExportSettingNode[];
}

export const settingPath = (parentPath: string, label: string): string =>
  parentPath ? `${parentPath}.${label}` : label;

export function collectOpenGroupPaths(nodes: ExportSettingNode[] = [], parentPath = ''): string[] {
  return nodes.flatMap((node) => {
    if (!node.children) return [];
    const path = settingPath(parentPath, node.label);
    return [path, ...collectOpenGroupPaths(node.children, path)];
  });
}
